import type { ReactNode } from 'react';
import { ErrorPage } from '@zg-rentals/visual-cohesion';
import { rentalsLoginOptions, rentalsStepUpLoginOptions } from '@zg-rentals/login-zillow';
import { zillowLoginRedirectHref } from '@zg-rentals/login-zillow/client';
import { Auth, hasAuth } from '../../AuthProvider';

const appName = 'leasing-web';

const loading = <>Loading…</>;
const redirecting = <>Redirecting…</>;
// oxlint-disable-next-line next/no-html-link-for-pages -- not a Next.js app; cross-app link to rental-manager-web
const fallback = <ErrorPage action={<a href="/rental-manager/">Go to Rental Manager</a>} />;

const forwardPrefix = __DEV__ ? '/rental-manager-api/forward' : undefined;

const loginRedirectHref = zillowLoginRedirectHref({
  entryPoint: appName,
  forwardPrefix,
  ...rentalsLoginOptions,
});

const mfaStepUpRedirectHref = zillowLoginRedirectHref({
  entryPoint: appName,
  forwardPrefix,
  ...rentalsLoginOptions,
  ...rentalsStepUpLoginOptions,
});

/**
 * Gates landlord leasing routes on Zillow Rental Manager auth: outer boundary
 * handles the initial login redirect, inner boundary handles MFA step-up.
 */
export function AuthBoundary({ children }: { children: ReactNode }) {
  return (
    <Auth.Boundary
      loading={loading}
      redirecting={redirecting}
      redirectHref={loginRedirectHref}
      onUnauthorized={fallback}
      onError={fallback}
    >
      <Auth.Boundary
        loading={loading}
        redirecting={redirecting}
        isAuthorized={hasAuth}
        redirectHref={mfaStepUpRedirectHref}
        searchParam={['sp', 'x']}
        onUnauthorized={fallback}
        onError={fallback}
      >
        {children}
      </Auth.Boundary>
    </Auth.Boundary>
  );
}
